<template>
  <div
    class="phone-gallery"
    :class="{
      'phone-gallery--screenshots': isScreenshotGallery,
      [`phone-gallery--count-${phones.length}`]: true,
    }"
    :aria-label="isScreenshotGallery ? galleryLabel : null"
    :aria-hidden="isScreenshotGallery ? null : 'true'"
  >
    <figure
      v-for="(phone, i) in phones"
      :key="phone.src || i"
      class="phone"
      :class="{ 'phone--screenshot': phone.src }"
      :style="phone.bg ? { background: phone.bg } : null"
    >
      <img v-if="phone.src" :src="phone.src" :alt="phone.alt">
      <span v-else>{{ phone.label }}</span>
    </figure>
  </div>
</template>

<script>
import gbScreen1 from '@/assets/gb-screens/gbwhatsapp-screen-1.webp';
import gbScreen2 from '@/assets/gb-screens/gbwhatsapp-screen-2.webp';
import gbScreen3 from '@/assets/gb-screens/gbwhatsapp-screen-3.webp';
import gbScreen4 from '@/assets/gb-screens/gbwhatsapp-screen-4.webp';
import fmScreen1 from '@/assets/fm-screens/fm-screen-1.webp';
import fmScreen2 from '@/assets/fm-screens/fm-screen-2.webp';
import fmScreen3 from '@/assets/fm-screens/fm-screen-3.webp';
import fmScreen4 from '@/assets/fm-screens/fm-screen-4.webp';
import yoScreen1 from '@/assets/yo-screens/yo-screen-1.webp';
import yoScreen2 from '@/assets/yo-screens/yo-screen-2.webp';
import yoScreen3 from '@/assets/yo-screens/yo-screen-3.webp';
import yoScreen4 from '@/assets/yo-screens/yo-screen-4.webp';
import blueScreen1 from '@/assets/blue-screens/blue-screen-1.webp';
import blueScreen2 from '@/assets/blue-screens/blue-screen-2.webp';
import blueScreen3 from '@/assets/blue-screens/blue-screen-3.webp';
import idScreen1 from '@/assets/wa-gb-screens/wagb-screen-1.webp';
import idScreen2 from '@/assets/wa-gb-screens/wagb-screen-2.webp';
import idScreen3 from '@/assets/wa-gb-screens/wagb-screen-3.webp';
import idScreen4 from '@/assets/wa-gb-screens/wagb-screen-4.webp';

export default {
  name: 'PhoneGallery',
  props: {
    theme: {
      type: String,
      default: 'green',
    },
    variant: {
      type: String,
      default: 'placeholder',
    },
  },
  computed: {
    isScreenshotGallery() {
      return this.variant === 'gb' || this.variant === 'fm' || this.variant === 'yo' || this.variant === 'blue' || this.variant === 'id';
    },
    galleryLabel() {
      if (this.variant === 'fm') return 'FM WhatsApp screenshots';
      if (this.variant === 'yo') return 'YO WhatsApp screenshots';
      if (this.variant === 'blue') return 'Blue WhatsApp screenshots';
      if (this.variant === 'id') return 'Tangkapan layar WA GB';
      return 'GB WhatsApp screenshots';
    },
    phones() {
      if (this.variant === 'gb') {
        return [
          { src: gbScreen1, alt: 'GB WhatsApp bubble and ticks settings screen' },
          { src: gbScreen2, alt: 'GB WhatsApp chat privacy settings screen' },
          { src: gbScreen3, alt: 'GB WhatsApp home screen' },
          { src: gbScreen4, alt: 'GB WhatsApp customization screen' },
        ];
      }

      if (this.variant === 'fm') {
        return [
          { src: fmScreen1, alt: 'FM WhatsApp screenshot 1' },
          { src: fmScreen2, alt: 'FM WhatsApp screenshot 2' },
          { src: fmScreen3, alt: 'FM WhatsApp screenshot 3' },
          { src: fmScreen4, alt: 'FM WhatsApp screenshot 4' },
        ];
      }

      if (this.variant === 'yo') {
        return [
          { src: yoScreen1, alt: 'YO WhatsApp screenshot 1' },
          { src: yoScreen2, alt: 'YO WhatsApp screenshot 2' },
          { src: yoScreen3, alt: 'YO WhatsApp screenshot 3' },
          { src: yoScreen4, alt: 'YO WhatsApp screenshot 4' },
        ];
      }

      if (this.variant === 'blue') {
        return [
          { src: blueScreen1, alt: 'Blue WhatsApp features screen' },
          { src: blueScreen2, alt: 'Blue WhatsApp themes screen' },
          { src: blueScreen3, alt: 'Blue WhatsApp Anti-Delete screen' },
        ];
      }

      if (this.variant === 'id') {
        return [
          { src: idScreen1, alt: 'Tampilan WA GB 1' },
          { src: idScreen2, alt: 'Tampilan WA GB 2' },
          { src: idScreen3, alt: 'Tampilan WA GB 3' },
          { src: idScreen4, alt: 'Tampilan WA GB 4' },
        ];
      }

      const palettes = {
        green: ['#075E54', '#128C7E', '#25D366', '#0B5D46'],
        blue: ['#0D47A1', '#1565C0', '#1E88E5', '#42A5F5'],
        teal: ['#004D40', '#00695C', '#00897B', '#26A69A'],
      };
      const colors = palettes[this.theme] || palettes.green;
      return colors.map((bg, i) => ({ bg, label: `Screen ${i + 1}` }));
    },
  },
};
</script>
